import md5 from 'md5';
import { getCookie, setCookie } from '@lucid/utils';

import { FeatureFlagVariations } from '../../types/types';
import { ABTestVariation } from './ab-test';

interface ABTestHelperProps {
  /** The A/B specific test name. */
  test: string;
  /** A the specific test variations. */
  testBranches?: FeatureFlagVariations | null;
  /** The name of the key to store the A/B test branch. */
  storageKey: string;
  /** Checks if the A/B test is in development mode. */
  isDevMode: boolean;
}

const createVisitorId = () => Math.floor(Math.random() * 2147483647).toString(36);

const getVariationAssignment = ({
  test,
  testBranches,
  storageKey,
  isDevMode,
}: ABTestHelperProps): {
  branch: ABTestVariation;
  isTestActive: boolean;
} => {
  if (typeof localStorage === 'undefined') {
    throw new Error('Local Storage not avaialble');
  }

  let branch = 'T-A';
  let isTestActive = false;

  if (testBranches) {
    const activeBranchCount = Object.values(testBranches).filter(value => value! > 0).length;

    if (activeBranchCount > 1) {
      isTestActive = true;
    }

    if (isTestActive || isDevMode) {
      // Check for localstorage key
      const localStorageBranch = localStorage.getItem(storageKey);
      if (localStorageBranch) {
        return { branch: localStorageBranch as ABTestVariation, isTestActive };
      }
    }

    const totalWeight = Object.values(testBranches).reduce((thisSum, a) => thisSum! + a!);
    let abVisitorId = getCookie('ab_id') || localStorage.getItem('abVisitorId');
    if (!abVisitorId) {
      abVisitorId = createVisitorId();
      localStorage.setItem('abVisitorId', abVisitorId);
      setCookie('ab_id', abVisitorId, {
        expires: 60 * 60 * 24 * 365.25 * 5,
        path: '/',
      });
    }
    // @ts-ignore
    const hash = md5(`${abVisitorId}|${test}`, { asBytes: true });
    let sum = 0;
    for (let i = 0; i < 8; i += 1) {
      // eslint-disable-next-line no-bitwise
      sum <<= 8;
      // @ts-ignore
      sum += hash[i];
    }

    sum = Math.abs(sum);
    let weightLeft = sum % totalWeight!;
    let last = '';
    const keys = Object.keys(testBranches);
    for (const option of keys) {
      const weight = testBranches[option as ABTestVariation];
      weightLeft -= weight!;
      last = option;
      if (weightLeft < 0) {
        break;
      }
    }

    branch = last;
    localStorage.setItem(storageKey, branch);
  } else {
    throw new Error(`Test named: ${test} is invalid or not present in the test config object`);
  }

  return { branch: branch as ABTestVariation, isTestActive };
};

export { createVisitorId, getVariationAssignment };
